import { TFunction } from 'react-i18next';
import { Currency, formatCurrency, formatDate } from '@chargify/formatters';
import { Coupon } from '../../../../models/subscription/types';
import { CouponErrorCodes } from '../../../../machines/subscription/types';

export const getAlertTitle = (
  { code, percentage, recurring, amountInCents }: Coupon,
  t: TFunction<'subscriptions-manager'[]>,
  currency: Currency
) => {
  const amount =
    amountInCents && formatCurrency(currency, amountInCents, currency);
  if (recurring) {
    return percentage
      ? t('coupons.recurring_percent', {
          percentage,
          code,
        })
      : t('coupons.recurring_amount', {
          code,
          amount,
        });
  }
  return percentage
    ? t('coupons.one_time_percent', {
        percentage,
        code,
      })
    : t('coupons.one_time_amount', {
        code,
        amount,
      });
};

export const getAlertMsg = (
  { percentage, amountInCents, expiresAt }: Coupon,
  t: TFunction<'subscriptions-manager'[]>,
  currency: Currency
) => {
  const amount =
    amountInCents && formatCurrency(currency, amountInCents, currency);
  const date = expiresAt && formatDate(expiresAt);
  if (expiresAt) {
    return percentage
      ? t('coupons.recurring_description_till', {
          value: `${percentage}%`,
          date,
        })
      : t('coupons.recurring_description_till', {
          value: `-${amount}`,
          date,
        });
  }
  return percentage
    ? t('coupons.recurring_description', {
        value: `${percentage}%`,
      })
    : t('coupons.recurring_description', {
        value: `-${amount}`,
      });
};

export const getCouponErrorMsg = (
  error: CouponErrorCodes,
  t: TFunction<'subscriptions-manager'[]>
) => {
  switch (error) {
    case 'CouponNotFound':
      return t('coupons.coupon_not_found');
    case 'NonStackableCoupon':
      return t('coupons.non_stackable_coupon');
    case 'CouponNoLongerActive':
      return t('coupons.coupon_no_longer_active');
    case 'InvalidCoupon':
      return t('coupons.invalid_coupon');
  }
};
